import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function PrivacyPolicyPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-[#FFF5EB]" data-id="element-209">
      {/* Header with back button */}
      <div className="bg-white shadow-sm sticky top-0 z-10" data-id="element-210">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-211">
          <button onClick={() => navigate('/')} className="inline-flex items-center text-[#E87B5C] hover:text-[#E87B5C]/80 transition-colors" data-id="element-212">
            <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-213" />
            Back to Home
          </button>
        </div>
      </div>

      {/* Privacy Policy Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-214">
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-215">
          <h1 className="text-4xl font-bold text-[#E87B5C] mb-8" data-id="element-216">
            Privacy Policy
          </h1>

          <div className="space-y-8 text-gray-700 text-justify" data-id="element-217">
            <div data-id="element-218">
              <p className="text-lg mb-4" data-id="element-219">
                <strong data-id="element-220">Last updated March 22, 2026</strong>
              </p>
              <p className="leading-relaxed mb-4" data-id="element-221">
                This Privacy Notice for Emigo Wellness, Inc. ("we," "us," or
                "our") explains how we process information in connection with
                Emigo. Emigo is designed to operate with minimal data access. We
                do not monitor, collect, or process what users type by default.
                Text or screenshots are only processed when a user actively
                submits content through a feature such as Reframe, Interpret, or
                Create. Emigo does not access prior conversations, messages in
                other apps, or background typing activity.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-222">
                We process your personal information when you use our services
                ("Services"), including when you:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-223">
                <li data-id="element-224">
                  Visit our website at joinemigo.com, or any website of ours
                  that links to this Privacy Notice
                </li>
                <li data-id="element-225">
                  Download and use our mobile application (Emigo), or any other
                  application of ours that links to this Privacy Notice
                </li>
                <li data-id="element-226">
                  Use Emigo, a texting companion using artificial intelligence
                  technology
                </li>
              </ul>
              <p className="leading-relaxed" data-id="element-227">
                <strong data-id="element-228">Questions or concerns?</strong> Reading this Privacy
                Notice will help you understand your privacy rights and choices.
                We are responsible for making decisions about how your personal
                information is processed. If you do not agree with our policies
                and practices, please do not use our Services. If you still have
                any questions or concerns, please contact us at
                support@joinemigo.com or Attn: Support, Emigo Wellness, 131
                Continental Drive, Suite 305, United States.
              </p>
            </div>

            <div data-id="element-229">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-230">
                Table of Contents
              </h2>
              <ul className="list-decimal list-inside space-y-1 ml-4 text-[#E87B5C]" data-id="element-231">
                <li data-id="element-232">
                  <a href="#section1" className="hover:underline" data-id="element-233">
                    What Information Do We Collect?
                  </a>
                </li>
                <li data-id="element-234">
                  <a href="#section2" className="hover:underline" data-id="element-235">
                    How Do We Process Your Information?
                  </a>
                </li>
                <li data-id="element-236">
                  <a href="#section3" className="hover:underline" data-id="element-237">
                    What Legal Bases Do We Rely On To Process Your Information?
                  </a>
                </li>
                <li data-id="element-238">
                  <a href="#section4" className="hover:underline" data-id="element-239">
                    When And With Whom Do We Share Your Personal Information?
                  </a>
                </li>
                <li data-id="element-240">
                  <a href="#section5" className="hover:underline" data-id="element-241">
                    Do We Use Cookies And Other Tracking Technologies?
                  </a>
                </li>
                <li data-id="element-242">
                  <a href="#section6" className="hover:underline" data-id="element-243">
                    Do We Offer Artificial Intelligence-Based Products?
                  </a>
                </li>
                <li data-id="element-244">
                  <a href="#section7" className="hover:underline" data-id="element-245">
                    Does Emigo Require Full Access?
                  </a>
                </li>
                <li data-id="element-246">
                  <a href="#section8" className="hover:underline" data-id="element-247">
                    How Long Do We Keep Your Information?
                  </a>
                </li>
                <li data-id="element-248">
                  <a href="#section9" className="hover:underline" data-id="element-249">
                    How Do We Keep Your Information Safe?
                  </a>
                </li>
                <li data-id="element-250">
                  <a href="#section10" className="hover:underline" data-id="element-251">
                    Do We Collect Information From Minors?
                  </a>
                </li>
                <li data-id="element-252">
                  <a href="#section11" className="hover:underline" data-id="element-253">
                    What Are Your Privacy Rights?
                  </a>
                </li>
                <li data-id="element-254">
                  <a href="#section12" className="hover:underline" data-id="element-255">
                    Do United States Residents Have Specific Privacy Rights?
                  </a>
                </li>
                <li data-id="element-256">
                  <a href="#section13" className="hover:underline" data-id="element-257">
                    Do We Make Updates To This Notice?
                  </a>
                </li>
                <li data-id="element-258">
                  <a href="#section14" className="hover:underline" data-id="element-259">
                    Third-Party Software Notices
                  </a>
                </li>
                <li data-id="element-260">
                  <a href="#section15" className="hover:underline" data-id="element-261">
                    How Can You Contact Us About This Notice?
                  </a>
                </li>
                <li data-id="element-262">
                  <a href="#section16" className="hover:underline" data-id="element-263">
                    How Can You Exercise Your Privacy Rights?
                  </a>
                </li>
              </ul>
            </div>

            <div id="section1" data-id="element-264">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-265">
                1. What Information Do We Collect?
              </h2>
              <p className="font-semibold mb-2" data-id="element-266">
                Personal information you disclose to us.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-267">
                <strong data-id="element-268">In Short:</strong> We only collect information necessary
                to provide our Services.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-269">
                We collect only the minimal information required to operate
                Emigo. This includes (i) standard device, usage, and diagnostic
                data automatically provided by your device, browser, or
                operating system, (ii) text or screenshots that you deliberately
                choose to process through Emigo's features such as Reframe,
                Interpret, or Create, and (iii) contact details you voluntarily
                provide when you email us for support. We do not require user
                registration or social-media login credentials, and we do not
                track or store precise location data.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-270">
                <strong data-id="element-271">Text Processing.</strong> When you use Emigo's features
                such as Reframe, Interpret, or Create, the text or screenshots
                you choose to process are transmitted securely to our AI service
                providers (for example, OpenAI, Anthropic, Google Gemini, and
                Meta Llama) solely to generate a response. These inputs and
                outputs are processed only for the requested functionality.
                Emigo does not retain or log user-submitted text or screenshots
                after processing, and does not use them for advertising,
                profiling, or analytics. See details provided in "DO WE OFFER
                ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?"
              </p>
              <p className="leading-relaxed mb-4" data-id="element-272">
                <strong data-id="element-273">Application Data.</strong> If you use our
                application(s), we also may collect the following information if
                you choose to provide us with access or permission:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-274">
                <li data-id="element-275">
                  <strong data-id="element-276">Mobile Device Data.</strong> We automatically collect
                  device information (such as your mobile device ID, model, and
                  manufacturer), operating system, version information and
                  system configuration information, device and application
                  identification numbers, browser type and version, hardware
                  model Internet service provider and/or mobile carrier, and
                  Internet Protocol (IP) address (or proxy server). If you are
                  using our application(s), we may also collect information
                  about the phone network associated with your mobile device,
                  your mobile device's operating system or platform, the type of
                  mobile device you use, your mobile device's unique device ID,
                  and information about the features of our application(s) you
                  accessed.
                </li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-277">
                This information is primarily needed to maintain the security
                and operation of our application(s), for troubleshooting, and
                for limited internal analytics and reporting purposes.
              </p>
              <p className="font-semibold mb-2" data-id="element-278">
                Information automatically collected.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-279">
                <strong data-id="element-280">In Short:</strong> We automatically collect limited
                device, usage, and diagnostic information when you visit, use,
                or navigate the Services.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-281">
                We automatically collect certain device, usage, and diagnostic
                information when you visit, use, or navigate the Services. This
                information does not reveal your specific identity, but may
                include your IP address, browser and device characteristics,
                operating system, language preferences, referring URLs, device
                name, general region derived from IP address, information about
                how and when you use our Services, and other technical
                information. This information is used primarily to maintain the
                security and operation of our Services and for limited internal
                analytics and reporting purposes.
              </p>
              <p className="leading-relaxed mb-2" data-id="element-282">
                The information we collect includes:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-283">
                <li data-id="element-284">
                  <strong data-id="element-285">Log and Usage Data.</strong> Log and usage data is
                  service-related, diagnostic, usage, and performance
                  information our servers automatically collect when you access
                  or use our Services and which we record in log files.
                  Depending on how you interact with us, this log data may
                  include your IP address, device information, browser type, and
                  settings and information about your activity in the Services
                  (such as the date/time stamps associated with your usage,
                  pages and files viewed, searches, and other actions you take
                  such as which features you use), device event information
                  (such as system activity, error reports (sometimes called
                  "crash dumps"), and hardware settings).
                </li>
                <li data-id="element-286">
                  <strong data-id="element-287">Device Data.</strong> We collect device data such as
                  information about your computer, phone, tablet, or other
                  device you use to access the Services. Depending on the device
                  used, this device data may include information such as your IP
                  address (or proxy server), device and application
                  identification numbers, location, browser type, hardware
                  model, Internet service provider and/or mobile carrier,
                  operating system, and system configuration information.
                </li>
                <li data-id="element-288">
                  <strong data-id="element-289">Location Data.</strong> Emigo does not access or track
                  precise location data. Limited, imprecise information (such as
                  IP-based region) may be used for security and diagnostic
                  purposes only.
                </li>
              </ul>
            </div>

            <div id="section2" data-id="element-290">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-291">
                2. How Do We Process Your Information?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-292">
                <strong data-id="element-293">In Short:</strong> We process your information only as
                necessary to provide, secure, maintain, and improve our
                Services, respond to inquiries, and comply with legal
                obligations.
              </p>
              <p className="leading-relaxed mb-2" data-id="element-294">
                We process your personal information for the following limited
                purposes:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-295">
                <li data-id="element-296">
                  <strong data-id="element-297">
                    To deliver and facilitate delivery of services to the user.
                  </strong>{' '}
                  We may process your information to provide you with the
                  requested service.
                </li>
                <li data-id="element-298">
                  <strong data-id="element-299">
                    To respond to user inquiries and provide support.
                  </strong>{' '}
                  We may process your information to respond to your inquiries
                  and solve issues related to the requested service.
                </li>
                <li data-id="element-300">
                  <strong data-id="element-301">To protect our Services.</strong> We may process your
                  information as part of our efforts to keep our Services safe
                  and secure, including fraud monitoring and prevention.
                </li>
                <li data-id="element-302">
                  <strong data-id="element-303">To identify usage trends.</strong> We may process
                  aggregate information about how the Services are used to
                  improve performance, reliability, and user experience.
                </li>
                <li data-id="element-304">
                  <strong data-id="element-305">
                    To comply with legal obligations and protect rights and
                    safety where necessary.
                  </strong>
                </li>
              </ul>
            </div>

            <div id="section3" data-id="element-306">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-307">
                3. What Legal Bases Do We Rely On To Process Your Information?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-308">
                <strong data-id="element-309">In Short:</strong> We only process your information when
                we believe it is necessary and we have a valid legal reason to
                do so under applicable law.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-310">
                We may process your information on the following bases, as
                permitted by applicable law:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-311">
                <li data-id="element-312">
                  <strong data-id="element-313">Consent.</strong> We may process your information if
                  you have given us permission to use it for a specific purpose.
                  You can withdraw your consent at any time by contacting us.
                </li>
                <li data-id="element-314">
                  <strong data-id="element-315">Performance of a Contract.</strong> We may process
                  your information when it is necessary to provide the Services
                  you request.
                </li>
                <li data-id="element-316">
                  <strong data-id="element-317">Legitimate Interests.</strong> We may process your
                  information when it is reasonably necessary for our legitimate
                  business interests, including to analyze aggregate usage of
                  the Services, improve performance and reliability, diagnose
                  problems, and prevent fraud or misuse.
                </li>
                <li data-id="element-318">
                  <strong data-id="element-319">Legal Obligations.</strong> We may process your
                  information where necessary to comply with law, regulation,
                  legal process, or governmental request.
                </li>
                <li data-id="element-320">
                  <strong data-id="element-321">Vital Interests.</strong> We may process your
                  information where necessary to protect the safety or rights of
                  any person.
                </li>
              </ul>
            </div>

            <div id="section4" data-id="element-322">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-323">
                4. When And With Whom Do We Share Your Personal Information?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-324">
                <strong data-id="element-325">In Short:</strong> We may share information in specific
                situations described in this section and/or with the following
                categories of third parties.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-326">
                We share limited data with service providers who help us operate
                Emigo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-327">
                <li data-id="element-328">
                  Cloud hosting and infrastructure providers that support the
                  secure transmission and operation of the Services;
                </li>
                <li data-id="element-329">
                  Analytics providers that help us understand aggregate website
                  or app usage; and
                </li>
                <li data-id="element-330">
                  AI service providers that process text or screenshots users
                  actively submit in order to generate responses.
                </li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-331">
                We do not sell personal information, and we do not share
                user-submitted content for advertising or profiling purposes.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-332">
                These providers act on our instructions, are required to keep
                your information confidential, and may not use it for their own
                independent purposes except as permitted by applicable law and
                their contractual obligations to us.
              </p>
              <p className="leading-relaxed mb-2" data-id="element-333">
                We also may need to share information in the following
                situations:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-334">
                <li data-id="element-335">
                  <strong data-id="element-336">Business Transfers.</strong> If Emigo is involved in a
                  merger, acquisition, or sale of assets, your information may
                  be transferred as part of that transaction under
                  confidentiality and data-protection requirements consistent
                  with this Notice.
                </li>
              </ul>
            </div>

            <div id="section5" data-id="element-337">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-338">
                5. Do We Use Cookies And Other Tracking Technologies?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-339">
                <strong data-id="element-340">In Short:</strong> We use only limited analytics and
                similar technologies necessary to understand general usage and
                performance. We do not use cookies or tracking technologies for
                targeted advertising or cross-site profiling.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-341">
                Emigo uses only essential cookies necessary for site
                functionality and limited analytics tools (such as Google
                Analytics) to understand aggregate website usage. We do not use
                advertising or tracking cookies. Some online tracking
                technologies help us maintain the security of our Services,
                prevent crashes, fix bugs, save your preferences, and assist
                with basic site functions.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-342">
                We do not permit third parties to use cookies or similar
                technologies on our Services for targeted advertising,
                cross-site profiling, or abandoned shopping cart reminders.
              </p>
              <p className="font-semibold mb-2" data-id="element-343">Google Analytics</p>
              <p className="leading-relaxed" data-id="element-344">
                We may use Google Analytics or similar analytics tools to
                understand aggregate use of the Services. We do not use Google
                Analytics Advertising Features, remarketing, or advertising
                personalization in connection with Emigo.
              </p>
            </div>

            <div id="section6" data-id="element-345">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-346">
                6. Do We Offer Artificial Intelligence-Based Products?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-347">
                <strong data-id="element-348">In Short:</strong> We offer AI-powered features that
                process only text or screenshots users actively submit in order
                to generate responses.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-349">
                As part of our Services, we offer products, features, or tools
                powered by artificial intelligence, machine learning, or similar
                technologies (collectively, "AI Products"). These tools are
                designed to enhance your experience and provide you with
                innovative solutions. The terms in this Privacy Notice govern
                your use of AI Products within our Services. When you engage
                with these AI features, text or screenshots that you actively
                submit are processed securely by third-party AI platforms for
                the sole purpose of generating a response.
              </p>
              <p className="font-semibold mb-2" data-id="element-350">Use of AI Technologies</p>
              <p className="leading-relaxed mb-4" data-id="element-351">
                We provide AI Products through third-party AI service providers,
                including OpenAI, Meta Llama, Anthropic, and Google (Gemini).
                When you use an Emigo feature, text or screenshots that you
                actively submit may be shared with and processed by these
                providers solely to generate a response and operate the
                requested functionality. We do not use user-submitted content
                for advertising, profiling, or analytics.
              </p>
              <p className="font-semibold mb-2" data-id="element-352">Our AI Products</p>
              <p className="leading-relaxed mb-4" data-id="element-353">
                Our AI Products are designed to help users reframe, interpret,
                and create messages.
              </p>
              <p className="font-semibold mb-2" data-id="element-354">
                How We Process Your Data Using AI
              </p>
              <p className="leading-relaxed" data-id="element-355">
                User-submitted content processed through our AI Products is
                handled in accordance with this Privacy Notice and our
                agreements with applicable service providers. Emigo does not
                retain or log user-submitted text or screenshots after
                processing.
              </p>
            </div>

            <div id="section7" data-id="element-356">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-357">
                7. Does Emigo Require Full Access?
              </h2>
              <p className="leading-relaxed" data-id="element-358">
                Yes. Emigo requires "Full Access" in order to send content that
                you choose to submit to our AI services and return results to
                you. Although iOS allows keyboards with Full Access to transmit
                typed data, Emigo does not monitor or collect what users type by
                default. The app does not capture keystrokes, does not track
                typing activity, and does not access sensitive information such
                as passwords or payment details except to the extent you
                intentionally submit content for processing through a feature
                such as Reframe, Interpret, or Create.
              </p>
            </div>

            <div id="section8" data-id="element-359">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-360">
                8. How Long Do We Keep Your Information?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-361">
                <strong data-id="element-362">In Short:</strong> We keep information only for as long
                as necessary to fulfill the purposes outlined in this Privacy
                Notice unless a longer retention period is required by law.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-363">
                We retain device, usage, support, and diagnostic information
                only for as long as reasonably necessary for the purposes
                described in this Privacy Notice. Emigo does not store user
                messages, submitted text, screenshots, or generated outputs
                beyond what is necessary to process a request in real time.
                User-submitted content is processed solely to generate a
                response and is not retained after processing. We also do not
                log user-submitted content.
              </p>
              <p className="leading-relaxed" data-id="element-364">
                If you contact us for support, we may retain support
                correspondence for as long as necessary to respond to your
                request, maintain records, and comply with legal obligations.
              </p>
            </div>

            <div id="section9" data-id="element-365">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-366">
                9. How Do We Keep Your Information Safe?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-367">
                <strong data-id="element-368">In Short:</strong> We aim to protect your personal
                information through a system of organizational and technical
                security measures.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-369">
                We have implemented appropriate and reasonable technical and
                organizational security measures designed to protect the
                security of any personal information we process. However,
                despite our safeguards and efforts to secure your information,
                no electronic transmission over the Internet or information
                storage technology can be guaranteed to be 100% secure, so we
                cannot promise or guarantee that hackers, cybercriminals, or
                other unauthorized third parties will not be able to defeat our
                security and improperly collect, access, steal, or modify your
                information. Although we will do our best to protect your
                personal information, transmission of personal information to
                and from our Services is at your own risk. You should only
                access the Services within a secure environment.
              </p>
              <p className="leading-relaxed" data-id="element-370">
                Emigo's AI features process only text or screenshots that users
                actively choose to submit through supported features.
                User-submitted content is not retained after processing, is not
                used for advertising, and is not linked by us to a user account.
              </p>
            </div>

            <div id="section10" data-id="element-371">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-372">
                10. Do We Collect Information From Minors?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-373">
                <strong data-id="element-374">In Short:</strong> We do not knowingly collect data from
                or market to children under 13 years of age.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-375">
                Emigo is not intended for children under 13 years of age. We do
                not knowingly collect personal information from anyone under 13
                years of age. If you are under 13, please do not use Emigo or
                provide any personal information.
              </p>
              <p className="leading-relaxed" data-id="element-376">
                If we learn that we have inadvertently collected personal
                information from a user under 13, we will promptly delete it.
                Parents or guardians who believe their child under 13 has
                provided information to us may contact support@joinemigo.com to
                request deletion.
              </p>
            </div>

            <div id="section11" data-id="element-377">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-378">
                11. What Are Your Privacy Rights?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-379">
                <strong data-id="element-380">In Short:</strong> Depending on your location, you may
                have rights to access, correct, delete, or object to the
                processing of personal information we maintain about you.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-381">
                Depending on where you reside, you may have certain rights under
                applicable privacy laws, including the right to request access
                to personal information we maintain about you, request
                correction or deletion, object to certain processing, or
                withdraw consent where processing is based on consent. You can
                make such a request by contacting us using the details provided
                in the section "HOW CAN YOU CONTACT US ABOUT THIS NOTICE?"
                below.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-382">
                We will consider and act upon any request in accordance with
                applicable data protection laws.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-383">
                <strong data-id="element-384">Withdrawing your consent.</strong> If we rely on your
                consent to process your information, you may withdraw that
                consent at any time by contacting us. This will not affect the
                lawfulness of any processing carried out before your withdrawal.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-385">
                If you have questions or comments about your privacy rights, you
                may email us at support@joinemigo.com.
              </p>
              <p className="leading-relaxed" data-id="element-386">
                Emigo does not require user accounts. If you contact us for
                support or otherwise provide personal information directly, you
                may request access to, correction of, or deletion of that
                information by contacting us at support@joinemigo.com, subject
                to applicable law.
              </p>
            </div>

            <div id="section12" data-id="element-387">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-388">
                12. Do United States Residents Have Specific Privacy Rights?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-389">
                <strong data-id="element-390">In Short:</strong> If you are a resident of California,
                Colorado, Connecticut, Delaware, Florida, Indiana, Iowa,
                Kentucky, Montana, New Hampshire, New Jersey, Oregon, Tennessee,
                Texas, Utah, or Virginia, you may have the right to request
                access to and receive details about the personal information we
                maintain about you and how we have processed it, correct
                inaccuracies, get a copy of, or delete your personal
                information. You may also have the right to withdraw your
                consent to our processing of your personal information. These
                rights may be limited in some circumstances by applicable law.
                More information is provided below.
              </p>
              <p className="font-semibold mb-2" data-id="element-391">
                Categories of Personal Information We Collect
              </p>
              <p className="leading-relaxed mb-4" data-id="element-392">
                We have collected the following categories of personal
                information in the past twelve (12) months:
              </p>
              <div className="overflow-x-auto mb-4" data-id="element-393">
                <table className="min-w-full border border-gray-300" data-id="element-394">
                  <thead className="bg-gray-100" data-id="element-395">
                    <tr data-id="element-396">
                      <th className="border border-gray-300 px-4 py-2 text-left" data-id="element-397">
                        Category
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-left" data-id="element-398">
                        Examples
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-left" data-id="element-399">
                        Collected
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-400">
                    <tr data-id="element-401">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-402">
                        A. Identifiers
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-403">
                        Contact details, such as real name, alias, postal
                        address, telephone or mobile contact number, unique
                        personal identifier, online identifier, Internet
                        Protocol address, email address, and account name
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-404">
                        Internet Protocol address, device or online identifiers,
                        and email address if support is contacted
                      </td>
                    </tr>
                    <tr data-id="element-405">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-406">
                        B. Personal information as defined in the California
                        Customer Records statute
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-407">
                        Name, contact information, education, employment,
                        employment history, and financial information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-408">NO</td>
                    </tr>
                    <tr data-id="element-409">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-410">
                        C. Protected classification characteristics under state
                        or federal law
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-411">
                        Gender, age, date of birth, race and ethnicity, national
                        origin, marital status, and other demographic data
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-412">NO</td>
                    </tr>
                    <tr data-id="element-413">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-414">
                        D. Commercial information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-415">
                        Transaction information, purchase history, financial
                        details, and payment information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-416">NO</td>
                    </tr>
                    <tr data-id="element-417">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-418">
                        E. Biometric information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-419">
                        Fingerprints and voiceprints
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-420">NO</td>
                    </tr>
                    <tr data-id="element-421">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-422">
                        F. Internet or other similar network activity
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-423">
                        Browsing history, search history, online behavior,
                        interest data, and interactions with our and other
                        websites, applications, systems, and advertisements
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-424">
                        Limited service usage, diagnostic, and analytics data
                        only
                      </td>
                    </tr>
                    <tr data-id="element-425">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-426">
                        G. Geolocation data
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-427">
                        Device location
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-428">NO</td>
                    </tr>
                    <tr data-id="element-429">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-430">
                        H. Audio, electronic, sensory, or similar information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-431">
                        Images and audio, video or call recordings created in
                        connection with our business activities
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-432">NO</td>
                    </tr>
                    <tr data-id="element-433">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-434">
                        I. Professional or employment-related information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-435">
                        Business contact details in order to provide you our
                        Services at a business level or job title, work history,
                        and professional qualifications if you apply for a job
                        with us
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-436">NO</td>
                    </tr>
                    <tr data-id="element-437">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-438">
                        J. Education Information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-439">
                        Student records and directory information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-440">NO</td>
                    </tr>
                    <tr data-id="element-441">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-442">
                        K. Inferences drawn from collected personal information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-443">
                        Inferences drawn from any of the collected personal
                        information listed above to create a profile or summary
                        about, for example, an individual's preferences and
                        characteristics
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-444">NO</td>
                    </tr>
                    <tr data-id="element-445">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-446">
                        L. Sensitive personal information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-447">
                        Sensitive personal information as defined by applicable
                        privacy laws
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-448">NO</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="leading-relaxed mb-4" data-id="element-449">
                We do not collect or process sensitive personal information for
                the purpose of inferring characteristics about you.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-450">
                We may also receive limited personal information when you
                contact us directly for support or submit a privacy rights
                request.
              </p>
              <p className="font-semibold mb-2" data-id="element-451">
                Sources of Personal Information
              </p>
              <p className="leading-relaxed mb-4" data-id="element-452">
                Learn more about the sources of personal information we collect
                in "WHAT INFORMATION DO WE COLLECT?"
              </p>
              <p className="font-semibold mb-2" data-id="element-453">
                How We Use and Share Personal Information
              </p>
              <p className="leading-relaxed mb-4" data-id="element-454">
                Learn about how we use your personal information in the section,
                "HOW DO WE PROCESS YOUR INFORMATION?"
              </p>
              <p className="font-semibold mb-2" data-id="element-455">
                Will your information be shared with anyone else?
              </p>
              <p className="leading-relaxed mb-4" data-id="element-456">
                We may disclose your personal information with our service
                providers pursuant to a written contract between us and each
                service provider. Learn more about how we disclose personal
                information in the section, "WHEN AND WITH WHOM DO WE SHARE YOUR
                PERSONAL INFORMATION?"
              </p>
              <p className="leading-relaxed mb-4" data-id="element-457">
                We have not sold or shared personal information to third parties
                for targeted advertising, cross-context behavioral advertising,
                or other sale or sharing activities as those terms are defined
                under applicable US state privacy laws in the preceding twelve
                (12) months. We have disclosed the following categories of
                personal information to third parties for a business or
                commercial purpose in the preceding twelve (12) months: The
                categories of third parties to whom we disclosed personal
                information for a business or commercial purpose can be found
                under "WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                INFORMATION?"
              </p>
              <p className="font-semibold mb-2" data-id="element-458">Your Rights</p>
              <p className="leading-relaxed mb-4" data-id="element-459">
                You have rights under certain US state data protection laws.
                However, these rights are not absolute, and in certain cases, we
                may decline your request as permitted by law. These rights
                include:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-460">
                <li data-id="element-461">
                  Right to know whether or not we are processing your personal
                  data
                </li>
                <li data-id="element-462">Right to access your personal data</li>
                <li data-id="element-463">Right to correct inaccuracies in your personal data</li>
                <li data-id="element-464">Right to request the deletion of your personal data</li>
                <li data-id="element-465">
                  Right to obtain a copy of the personal data you previously
                  shared with us
                </li>
                <li data-id="element-466">Right to non-discrimination for exercising your rights</li>
                <li data-id="element-467">
                  Right to opt out of the processing of your personal data if it
                  is used for targeted advertising, the sale of personal data,
                  or profiling in furtherance of decisions that produce legal or
                  similarly significant effects ("profiling"), to the extent
                  applicable law provides such rights
                </li>
              </ul>
              <p className="font-semibold mb-2" data-id="element-468">How to Exercise Your Rights</p>
              <p className="leading-relaxed mb-4" data-id="element-469">
                To exercise these rights, you can contact us by submitting a
                data subject access request, by emailing us at
                support@joinemigo.com, or by referring to the contact details at
                the bottom of this document.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-470">
                Under certain US state data protection laws, you can designate
                an authorized agent to make a request on your behalf. We may
                deny a request from an authorized agent that does not submit
                proof that they have been validly authorized to act on your
                behalf in accordance with applicable laws.
              </p>
              <p className="font-semibold mb-2" data-id="element-471">Request Verification</p>
              <p className="leading-relaxed mb-4" data-id="element-472">
                Upon receiving your request, we will need to verify your
                identity to determine you are the same person about whom we have
                the information in our system. We will only use personal
                information provided in your request to verify your identity or
                authority to make the request. However, if we cannot verify your
                identity from the information already maintained by us, we may
                request that you provide additional information for the purposes
                of verifying your identity and for security or fraud-prevention
                purposes.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-473">
                If you submit the request through an authorized agent, we may
                need to collect additional information to verify your identity
                before processing your request and the agent will need to
                provide a written and signed permission from you to submit such
                request on your behalf.
              </p>
              <p className="font-semibold mb-2" data-id="element-474">Appeals</p>
              <p className="leading-relaxed" data-id="element-475">
                Under certain US state data protection laws, if we decline to
                take action regarding your request, you may appeal our decision
                by emailing us at support@joinemigo.com. We will inform you in
                writing of any action taken or not taken in response to the
                appeal, including a written explanation of the reasons for the
                decisions. If your appeal is denied, you may submit a complaint
                to your state attorney general.
              </p>
            </div>

            <div id="section13" data-id="element-476">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-477">
                13. Do We Make Updates To This Notice?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-478">
                <strong data-id="element-479">In Short:</strong> Yes, we will update this notice as
                necessary to stay compliant with relevant laws.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-480">
                We may update this Privacy Notice from time to time. The updated
                version will be indicated by an updated "Last updated" date at
                the top of this Privacy Notice. If we make material changes to
                this Privacy Notice, we may notify you either by prominently
                posting a notice of such changes or by directly sending you a
                notification. We will post the revised Privacy Policy on our
                website with an updated "Last updated" date and encourage you to
                review it regularly.
              </p>
            </div>

            <div id="section14" data-id="element-481">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-482">
                14. Third-Party Software Notices
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-483">
                Emigo includes third-party software components. Some of these
                components are open source and provided under their respective
                license terms, while others are used under commercial or
                proprietary license agreements.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-484">
                As part of the Emigo iOS application, Emigo currently includes
                PostHog iOS, version 3.37.2, which is made available under the
                MIT License.
              </p>
              <p className="font-semibold mb-2" data-id="element-485">MIT License</p>
              <p className="leading-relaxed mb-4" data-id="element-486">Copyright (c) 2023 PostHog</p>
              <p className="leading-relaxed mb-4" data-id="element-487">
                Permission is hereby granted, free of charge, to any person
                obtaining a copy of this software and associated documentation
                files (the "Software"), to deal in the Software without
                restriction, including without limitation the rights to use,
                copy, modify, merge, publish, distribute, sublicense, and/or
                sell copies of the Software, and to permit persons to whom the
                Software is furnished to do so, subject to the following
                conditions:
              </p>
              <p className="leading-relaxed mb-4" data-id="element-488">
                The above copyright notice and this permission notice shall be
                included in all copies or substantial portions of the Software.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-489">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
                EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
                OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
                HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES, OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT, OR OTHERWISE, ARISING
                FROM, OUT OF, OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
                OTHER DEALINGS IN THE SOFTWARE.
              </p>
              <p className="leading-relaxed" data-id="element-490">
                Emigo also includes commercially licensed software components,
                including KeyboardKit, version 10.3.0, and LicenseKit, version
                2.1.3. These components are provided under applicable vendor
                license terms, are not open source, and are used in accordance
                with their commercial licenses.
              </p>
            </div>

            <div id="section15" data-id="element-491">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-492">
                15. How Can You Contact Us About This Notice?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-493">
                If you have questions or comments about this notice, you may
                email us at support@joinemigo.com or contact us by post at:
              </p>
              <p className="leading-relaxed" data-id="element-494">
                Attn: Support, Emigo Wellness, 131 Continental Drive, Suite 305,
                United States.
              </p>
            </div>

            <div id="section16" data-id="element-495">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-496">
                16. How Can You Exercise Your Privacy Rights?
              </h2>
              <p className="leading-relaxed" data-id="element-497">
                Depending on where you reside and subject to applicable law, you
                may have the right to request access to, correction of, or
                deletion of personal information we maintain about you. To
                exercise any available privacy rights, please contact us at
                support@joinemigo.com.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}